import restful from '@/utils/restful';
import * as names from '@/store/names';
import * as get from '@/store/store';

// "Modulo" en la UI (nombre alternativo por institución).
const state = {
    instructional_modules: [],
    instructional_modules_url: '/teaching/instructional-module'
}

const getters = {
    [names.INSTRUCTIONAL_MODULES]: state => {
        if (!get.store.state.user) return [];
        return state.instructional_modules
            .filter((x) => x.school == get.store.state.user.school)
            .sort(function (a, b) {
                if (a.order > b.order) return 1;
                if (a.order < b.order) return -1;
                return 0;
            });
    },
    [names.INSTRUCTIONAL_MODULE]: (state,) => id => {
        return state.instructional_modules.find(x => x.id == id);
    },
}

const mutations = {
    [names.MUTATE_INSTRUCTIONAL_MODULES]: (state, instructional_modules) => {
        instructional_modules.forEach(element => {
            let index = state.instructional_modules.findIndex(x => x.id == element.id);
            if (index != -1) state.instructional_modules.splice(index, 1, element);
            else state.instructional_modules.push(element);
        });
        state.instructional_modules.sort(function (a, b) {
            return ((a.order < b.order) ? -1 : ((a.order > b.order) ? 1 : 0));
        });
    },
    [names.MUTATE_INSTRUCTIONAL_MODULE]: (state, instructional_module) => {
        let index = state.instructional_modules.findIndex(x => x.id == instructional_module.id);
        if (index != -1) state.instructional_modules.splice(index, 1, instructional_module);
        else state.instructional_modules.push(instructional_module);
        state.instructional_modules.sort(function (a, b) {
            return ((a.order < b.order) ? -1 : ((a.order > b.order) ? 1 : 0));
        });
    },
    [names.MUTATE_DELETE_INSTRUCTIONAL_MODULE]: (state, instructional_module_id) => {
        let index = state.instructional_modules.findIndex(x => x.id == instructional_module_id);
        if (index != -1) state.instructional_modules.splice(index, 1);
    },
}

const actions = {
    [names.FETCH_INSTRUCTIONAL_MODULE]: ({
        commit,
        state
    }, instructional_module_id) => {
        return new Promise((resolve, reject) => {
            const instance = state.instructional_modules.find(x => x.id == instructional_module_id);
            if (instance) {
                resolve(instance);
                return;
            }
            restful.Get(`${state.instructional_modules_url}/${instructional_module_id}/`)
                .then(response => {
                    commit(names.MUTATE_INSTRUCTIONAL_MODULE, response);
                    resolve(response);
                })
                .catch(error => reject(error));
        });
    },
    // payload: { instructional_design_id, force }
    [names.FETCH_INSTRUCTIONAL_MODULES]: ({
        commit,
        state,
    }, payload = {}) => {
        const { instructional_design_id = null, force = false } = payload;
        return new Promise((resolve, reject) => {
            if (!force && instructional_design_id != null) {
                const cached = state.instructional_modules.filter(
                    x => x.instructional_design == instructional_design_id
                );
                if (cached.length > 0) {
                    resolve(cached);
                    return;
                }
            }
            const query = instructional_design_id != null
                ? `?instructional_design=${instructional_design_id}`
                : '';
            restful.GetAll(`${state.instructional_modules_url}/${query}`)
                .then(response => {
                    commit(names.MUTATE_INSTRUCTIONAL_MODULES, response);
                    resolve(response);
                })
                .catch(error => reject(error));
        });
    },
    [names.POST_INSTRUCTIONAL_MODULE]: ({
        commit,
        state
    }, instructional_module) => {
        return new Promise((resolve, reject) => {
            restful.Post(`${state.instructional_modules_url}/`, instructional_module)
                .then(response => {
                    commit(names.MUTATE_INSTRUCTIONAL_MODULE, response);
                    resolve(response);
                })
                .catch(error => reject(error));
        });
    },
    [names.UPDATE_INSTRUCTIONAL_MODULE]: ({
        commit,
        state
    }, instructional_module) => {
        return new Promise((resolve, reject) => {
            restful.Put(`${state.instructional_modules_url}/${instructional_module.id}/`, instructional_module)
                .then(response => {
                    commit(names.MUTATE_INSTRUCTIONAL_MODULE, response);
                    resolve(response);
                })
                .catch(error => reject(error));
        });
    },
    // payload: { instructional_module_id, item }
    [names.PATCH_INSTRUCTIONAL_MODULE]: ({
        commit,
        state
    }, payload) => {
        return new Promise((resolve, reject) => {
            restful.Patch(`${state.instructional_modules_url}/${payload.instructional_module_id}/`, payload.item)
                .then(response => {
                    commit(names.MUTATE_INSTRUCTIONAL_MODULE, response);
                    resolve(response);
                })
                .catch(error => reject(error));
        });
    },
    [names.DELETE_INSTRUCTIONAL_MODULE]: ({
        commit,
        state
    }, instructional_module_id) => {
        return new Promise((resolve, reject) => {
            restful.Delete(`${state.instructional_modules_url}/${instructional_module_id}/`)
                .then(response => {
                    commit(names.MUTATE_DELETE_INSTRUCTIONAL_MODULE, instructional_module_id);
                    resolve(response);
                })
                .catch(error => reject(error));
        });
    },
}

export default {
    state,
    getters,
    mutations,
    actions,
};
